const landing_page = {
  aboutUs: "Apie mus", // translated 
  topPackages: "Populiariausi paketai", // translated 
  featuredHotels: "Teminiai viešbučiai", // translated 
  topTours: "Populiariausios ekskursijos", // translated 
  whatOurMembersSay: "Ką sako mūsų nariai...", // translated 
  followUsOnInstagram: "Sekite mus Instagram", // translated 
  pleaseWait: "Prašau palauk...", // translated 
  packages: "Paketai", // translated 
  ourPartners: "Mūsų partneriai", // translated 
  trustedCarHirePartners: "Patikimi automobilių nuomos partneriai", // translated 
  learnMore: "Sužinokite daugiau", // translated 
};



export default landing_page;
